module.exports = __webpack_public_path__ + "img/r9.c248b06a.svg";